module.exports = __webpack_public_path__ + "img/macan.30927483.png";